



























































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import {HTデータ取込対象一覧取得結果型, HTデータ取込対象型} from '@/type/purchaseorder/item';
import { progress } from '@/script/progress';
import { loginModule } from '@/store/authentication/login';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import moment from 'moment';
import {
  ハンディ移動検索結果レコード型,
  ハンディ移動検索依頼型,
  ハンディ移動削除依頼型,
  toハンディ移動削除依頼,
  toハンディ移動検索結果, toハンディ移動取込依頼レコード, ハンディ移動取込依頼レコード型,
} from '@/type/movement/records/handy/ハンディ移動取込';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import api from '@/infrastructure/api/api';
import movementApi from '@/infrastructure/api/movement/movementApi';
import ハンディ移動取込チェッカー from '@/type/movement/records/handy/ハンディ移動取込チェッカー';
import ハンディ移動検索条件チェッカー from '@/type/movement/records/handy/ハンディ移動検索条件チェッカー';

@Component({
  components: {
    NormalDialog,
    AlertDialog,
    NormalButton,
    ConfirmDialog,
    Datepicker,
    AmountField,
  },
})

export default class HandyMovementImport extends Vue {
  検索条件: ハンディ移動検索依頼型 = {...this.デフォルトの検索条件};
  検索結果: ハンディ移動検索結果レコード型[] = [];
  削除対象: ハンディ移動検索結果レコード型 | null = null;

  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;

  HT機器一覧: HTデータ取込対象型[] = [];

  @Prop({required: true})
  selectedDepartmentCode!: string;

  // events
  // computed
  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 表示件数を取得() {
    return this.検索結果.length;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get デフォルトの検索条件(): ハンディ移動検索依頼型 {
    return {
      在庫部署コード: this.selectedDepartmentCode,
      機械番号: '',
      検索移動年月日: moment().format('YYYY-MM-DD'),
    };
  }

  // methods
  async HT機器一覧取得() {
    const HTデータ取込対象取得結果 = await api.HTデータ取込対象一覧を取得する()
            .then((response: HTデータ取込対象一覧取得結果型) => {
              this.HT機器一覧 = response.ハンディデータ取込対象リスト;
              this.HT機器一覧.push({ 機械番号: '', 端末名: '指定なし' });
            })
            .catch((error: any) => {
              this.HT機器一覧 = [];
              this.showAlert(error.data.message);
            });
  }

  async 検索するハンドラ(): Promise<void> {
    const checker = new ハンディ移動検索条件チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }

    if (this.検索結果.some((it) => it.選択 === true)) {
      this.$modal.show('選択中確認ダイアログ');
      return;
    }
    this.検索する();
  }

  async 検索する(): Promise<void> {
    this.$modal.hide('選択中確認ダイアログ');

    const 検索処理 = async (): Promise<void> => {
      this.検索結果 = [];
      this.検索条件.在庫部署コード = this.selectedDepartmentCode;
      await movementApi.ハンディ移動を検索する(this.検索条件)
              .then((response: any) => {
                const ハンディ移動検索結果レコード一覧: ハンディ移動検索結果レコード型[] = response.ハンディ移動検索結果レコード一覧;
                this.検索結果 =  ハンディ移動検索結果レコード一覧.map((record) => toハンディ移動検索結果(record));
                if (this.検索結果.length === 0) {
                  this.showAlert('検索結果が0件です。');
                  return;
                }
                if (response.アラートメッセージ) {
                  this.showAlert(response.アラートメッセージ);
                }
              }).catch((error: any) => {
                this.showAlert(error.data.message);
              });
    };
    await progress(検索処理);
  }

  選択中確認ダイアログを閉じる(): void {
    this.$modal.hide('選択中確認ダイアログ');
  }

  async 確定するハンドラ() {
    const 取込対象一覧 = this.検索結果.filter((ハンディ移動) => ハンディ移動.選択 === true);
    if (取込対象一覧.length === 0) {
      this.showAlert('ハンディ移動の取込対象が存在しません');
      return;
    }

    const checker = new ハンディ移動取込チェッカー(取込対象一覧, this.バラ管理である);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    await progress(this.確定する);
  }

  async 確定する(): Promise<void> {
    const 取込対象一覧 = this.検索結果.filter((ハンディ移動) => ハンディ移動.選択 === true);
    const ハンディ移動取込一覧 = new Array<ハンディ移動取込依頼レコード型>();
    for (const ハンディ移動取込 of 取込対象一覧) {
      ハンディ移動取込一覧.push(toハンディ移動取込依頼レコード(ハンディ移動取込));
    }
    await movementApi.ハンディ移動を取り込む(ハンディ移動取込一覧)
            .then(() => {
              this.clear();
              this.close();
            })
            .catch((error: any) => {
              if (error.data.errors) {
                this.アラートメッセージ = error.data.errors;
              }
              if (error.data.message && !error.data.errors) {
                this.アラートメッセージ = [error.data.message];
              }
              this.showAlert(this.アラートメッセージ);
            });
  }

  ハンディ移動の削除を確認する(record: ハンディ移動検索結果レコード型): void {
    this.削除対象 = record;
    this.削除ダイアログを開く();
  }

  async ハンディ移動を削除する(): Promise<void> {
    this.アラートメッセージ = [];
    if (this.削除対象 === null) return;

    const ハンディ移動削除依頼: ハンディ移動削除依頼型 = toハンディ移動削除依頼(this.削除対象);

    const 削除処理 = async (): Promise<void> => {
      const 削除対象ハンディ移動シーケンス番号 = (this.削除対象 !== null) ? this.削除対象.ハンディ移動シーケンス番号 : 0;
      await movementApi.ハンディ移動を削除する(ハンディ移動削除依頼)
              .then(async (response: void) => {
                this.検索結果 = this.検索結果.filter((value, index) => value.ハンディ移動シーケンス番号 !== 削除対象ハンディ移動シーケンス番号);
              }).catch((error: any) => {
                this.showAlert(error.data.message);
              });
      this.削除対象 = null;
    };

    await progress(削除処理);
    this.削除ダイアログを閉じる();
  }

  ハンディ移動の削除をキャンセルする(): void {
    this.削除対象 = null;
    this.削除ダイアログを閉じる();
  }

  削除ダイアログを開く(): void {
    this.$modal.show('部署間移動HTデータ取込削除ダイアログ');
  }

  削除ダイアログを閉じる(): void {
    this.$modal.hide('部署間移動HTデータ取込削除ダイアログ');
  }

  中止する(): void {
    this.clear();
    this.close();
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  全解除する(): void {
    for (const レコード of this.検索結果) {
      レコード.選択 = false;
    }
    this.$forceUpdate();
  }

  全選択する(): void {
    for (const レコード of this.検索結果) {
      レコード.選択 = true;
    }
    this.$forceUpdate();
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('部署間移動HTデータ取込アラート');
  }

  clear(): void {
    this.検索条件 = {...this.デフォルトの検索条件};
    this.検索結果 = [];
    this.アラートメッセージ = null;
  }

  close(): void {
    this.$modal.hide('部署間移動HTデータ取込画面');
  }

  // lifecycle hook
  async mounted(): Promise<void> {
    await this.HT機器一覧取得();
  }

  private 数値入力エラー判定(行番号: number, 項目名: string): boolean {
    const checker = new ハンディ移動取込チェッカー(this.検索結果, this.バラ管理である);
    return checker.hasError(項目名, 行番号);
  }
  // nothing

  private 検索移動年月日入力エラー判定(項目名: string): boolean {
    const checker = new ハンディ移動検索条件チェッカー(this.検索条件);
    return checker.hasError(項目名);
  }
}
